const appEnv = {};

if(window){
    Object.assign(appEnv, window.__env);
}

export default appEnv;
